import Api from './api';

export default class ProductSelectorController {
	constructor() {
		this.dom = {
			container: document.querySelector("section.productSelector")
		};
		this.containers = [];
		this.api = new Api();

		if (this.dom.container != null) {
			this.init();
		}
	}

	init() {
		this.setOptions();
		this.setEventListeners();
	}

	setOptions() {
		this.dom.form = this.dom.container.querySelector('form');
		this.dom.renovateOptions = this.dom.form.querySelectorAll('input[name=renovateRoom');
		this.dom.bodyEffectStep = this.dom.form.querySelector('[data-substep="bodyEffect"]')
		this.dom.bodyEffectOptions = this.dom.form.querySelectorAll('input[name=bodyEffect');
		this.dom.styleStep = this.dom.form.querySelector('[data-substep="style"]')
		this.dom.styleOptions = this.dom.form.querySelectorAll('input[name=style]');

		if (this.dom.form.querySelector("input[name=questionsPage]")) {
			this.questionsPage = this.dom.form.querySelector("input[name=questionsPage]").value;
		}
		if (this.dom.form.querySelector("input[name=culture]")) {
			this.culture = this.dom.form.querySelector("input[name=culture]").value;
		}
		this.dom.nextStepButton = this.dom.form.querySelector(".buttonLarge.nextStep");
	}

	setEventListeners() {
		this.dom.renovateOptions.forEach((option) => {
			option.addEventListener('change', () => {
				this.dom.bodyEffectOptions.forEach((bodyOption) => bodyOption.checked = false);
				this.dom.styleOptions.forEach((styleOption) => styleOption.checked = false);
				this.getRemainingOptions().then(remainingOptions => {
					if (remainingOptions > 1) {
						this.dom.styleStep.classList.remove("show");
						this.dom.bodyEffectStep.classList.add("show");
						this.dom.nextStepButton.classList.remove("show");
					} else {
						this.dom.styleStep.classList.remove("show");
						this.dom.bodyEffectStep.classList.remove("show");
						this.dom.nextStepButton.classList.add("show");
					}
				});
			});
		});
		this.dom.bodyEffectOptions.forEach((option) => {
			option.addEventListener('change', () => {
				this.dom.styleOptions.forEach((styleOption) => styleOption.checked = false);
				this.getRemainingOptions().then(remainingOptions => {
					if (remainingOptions > 1) {
						this.dom.styleStep.classList.add("show");
						this.dom.nextStepButton.classList.remove("show");
					} else {
						this.dom.styleStep.classList.remove("show");
						this.dom.nextStepButton.classList.add("show");
					}
				});
			});
		});
		this.dom.styleOptions.forEach((option) => {
			option.addEventListener('change', () => {
				this.dom.nextStepButton.classList.add("show");
			});
		});

		this.initDisableSubmit();
	}

	getRemainingOptions() {
		let activeRenovateOption = "";
		this.dom.renovateOptions.forEach(radio => {
			if (radio.checked) {
				activeRenovateOption = radio.value;
			}
		});
		let activeBodyEffectOption = "";
		this.dom.bodyEffectOptions.forEach(radio => {
			if (radio.checked) {
				activeBodyEffectOption = radio.value;
			}
		});
		let activeStyleOption = "";
		this.dom.styleOptions.forEach(radio => {
			if (radio.checked) {
				activeStyleOption = radio.value;
			}
		});


		return this.api.GetOptions({
			QuestionsPage: this.questionsPage,
			Culture: this.culture,
			Renovate: activeRenovateOption,
			BodyEffect: activeBodyEffectOption,
			Style: activeStyleOption
		});
	}

	initDisableSubmit() {
		if (document.querySelector('.productSelectorDisableCheckboxes')) {

			// get a list of the checkboxes and spread it into an array
			// so later you can use Array methods on it
			let checkboxes = Array.from(document.querySelectorAll('.productSelectorDisableCheckboxes input[type=checkbox]'))

			let submitbtn = document.querySelectorAll('#submitbtn')[0];

			// function that tells you if any checkboxes in
			// the above list are checked
			function anyChecked() {
				// this is where we're using an array method
				// Array.prototype.some
				return checkboxes.some(x => x.checked)
			}

			// to every single checkbox, add a click listener
			// again, using an Array method
			// Array.prototype.forEach
			checkboxes.forEach(checkbox => {
				checkbox.addEventListener('change', () => {
					// when any checkbox is clicked,
					// check if there's any checked checkboxes
					anyChecked()
						// if so, enable the button
						?
						submitbtn.removeAttribute('disabled')
						// otherwise, disable it
						:
						submitbtn.setAttribute('disabled', '')
				})
			})

			// do the same thing initially as well 
			// to account for initially checked checkboxes
			anyChecked() ?
				submitbtn.removeAttribute('disabled') :
				submitbtn.setAttribute('disabled', '')
		}
	}
}